/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1BannerQueryResponse,
  GetApiV1BannerQueryParams,
  GetApiV1Banner401,
  GetApiV1Banner500,
} from "../../types/bannerRegistroController/GetApiV1Banner.ts";

function getGetApiV1BannerUrl() {
  const res = { method: "GET", url: `/api/v1/banner` as const };
  return res;
}

/**
 * @description Retorna uma lista paginada de banners. Filtra por empresa, título e status. **(Requer Authorization para autenticação)**
 * @summary Listar banners (Requer Authorization para autenticação)
 * {@link /api/v1/banner}
 */
export async function getApiV1Banner(
  params?: GetApiV1BannerQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1BannerQueryResponse,
    ResponseErrorConfig<GetApiV1Banner401 | GetApiV1Banner500>,
    unknown
  >({
    method: "GET",
    url: getGetApiV1BannerUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
